import * as React from "react"

interface Props {
  centerX: string,
  centerY: string,
  signRadius: string,
  signBorderRadius: string,
  outerRadius: string,
  innerRadius: string,
  houseRadius: string,
  centerRadius: string,
  DegreeSym: string,
  AriSignX: string,
  AriSignY: string,
  TauSignX: string,
  TauSignY: string,
  GemSignX: string,
  GemSignY: string,
  CanSignX: string,
  CanSignY: string,
  LeoSignX: string,
  LeoSignY: string,
  VirSignX: string,
  VirSignY: string,
  LibSignX: string,
  LibSignY: string,
  ScoSignX: string,
  ScoSignY: string,
  SagSignX: string,
  SagSignY: string,
  CapSignX: string,
  CapSignY: string,
  AquSignX: string,
  AquSignY: string,
  PisSignX: string,
  PisSignY: string,
  RXSym: string,
  MoPlanetX: string,
  MoPlanetY: string,
  MoSym:string,
  MoSign: string,
  MoSignSym: string,
  MoSignX: string,
  MoSignY: string,
  MoDegree: string,
  MoDegreeX: string,
  MoDegreeY: string,
  MoMinute: string,
  MoMinuteX: string,
  MoMinuteY: string,
  VeSym:string,
  VePlanetX: string,
  VePlanetY: string,
  VeSign: string,
  VeSignSym: string,
  VeSignX: string,
  VeSignY: string,
  VeDegree: string,
  VeDegreeX: string,
  VeDegreeY: string,
  VeMinute: string,
  VeMinuteX: string,
  VeMinuteY: string,
  VeRX: boolean,
  VeRXX: string,
  VeRXY: string,
  ASCSym:string,
  ASCPlanetX: string,
  ASCPlanetY: string,
  ASCSign: string,
  ASCSignSym: string,
  ASCSignX: string,
  ASCSignY: string,
  ASCDegree: string,
  ASCDegreeX: string,
  ASCDegreeY: string,
  ASCMinute: string,
  ASCMinuteX: string,
  ASCMinuteY: string,
  RaSym:string,
  RaPlanetX: string,
  RaPlanetY: string,
  RaSign: string,
  RaSignSym: string,
  RaSignX: string,
  RaSignY: string,
  RaDegree: string,
  RaDegreeX: string,
  RaDegreeY: string,
  RaMinute: string,
  RaMinuteX: string,
  RaMinuteY: string,
  RaRX: boolean,
  RaRXX: string,
  RaRXY: string,
  SuSym:string,
  SuPlanetX: string,
  SuPlanetY: string,
  SuSign: string,
  SuSignSym: string,
  SuSignX: string,
  SuSignY: string,
  SuDegree: string,
  SuDegreeX: string,
  SuDegreeY: string,
  SuMinute: string,
  SuMinuteX: string,
  SuMinuteY: string,
  ChSym:string,
  ChPlanetX: string,
  ChPlanetY: string,
  ChSign: string,
  ChSignSym: string,
  ChSignX: string,
  ChSignY: string,
  ChDegree: string,
  ChDegreeX: string,
  ChDegreeY: string,
  ChMinute: string,
  ChMinuteX: string,
  ChMinuteY: string,
  ChRX: boolean,
  ChRXX: string,
  ChRXY: string,
  MeSym:string,
  MePlanetX: string,
  MePlanetY: string,
  MeSign: string,
  MeSignSym: string,
  MeSignX: string,
  MeSignY: string,
  MeDegree: string,
  MeDegreeX: string,
  MeDegreeY: string,
  MeMinute: string,
  MeMinuteX: string,
  MeMinuteY: string,
  MeRX: boolean,
  MeRXX: string,
  MeRXY: string,
  JuSym:string,
  JuPlanetX: string,
  JuPlanetY: string,
  JuSign: string,
  JuSignSym: string,
  JuSignX: string,
  JuSignY: string,
  JuDegree: string,
  JuDegreeX: string,
  JuDegreeY: string,
  JuMinute: string,
  JuMinuteX: string,
  JuMinuteY: string,
  JuRX: boolean,
  JuRXX: string,
  JuRXY: string,
  UrSym:string,
  UrPlanetX: string,
  UrPlanetY: string,
  UrSign: string,
  UrSignSym: string,
  UrSignX: string,
  UrSignY: string,
  UrDegree: string,
  UrDegreeX: string,
  UrDegreeY: string,
  UrMinute: string,
  UrMinuteX: string,
  UrMinuteY: string,
  UrRX: boolean,
  UrRXX: string,
  UrRXY: string,
  ICSym:string,
  ICPlanetX: string,
  ICPlanetY: string,
  ICSign: string,
  ICSignSym: string,
  ICSignX: string,
  ICSignY: string,
  ICDegree: string,
  ICDegreeX: string,
  ICDegreeY: string,
  ICMinute: string,
  ICMinuteX: string,
  ICMinuteY: string,
  DSCSym:string,
  DSCPlanetX: string,
  DSCPlanetY: string,
  DSCSign: string,
  DSCSignSym: string,
  DSCSignX: string,
  DSCSignY: string,
  DSCDegree: string,
  DSCDegreeX: string,
  DSCDegreeY: string,
  DSCMinute: string,
  DSCMinuteX: string,
  DSCMinuteY: string,
  KeSym:string,
  KePlanetX: string,
  KePlanetY: string,
  KeSign: string,
  KeSignSym: string,
  KeSignX: string,
  KeSignY: string,
  KeDegree: string,
  KeDegreeX: string,
  KeDegreeY: string,
  KeMinute: string,
  KeMinuteX: string,
  KeMinuteY: string,
  KeRX: boolean,
  KeRXX: string,
  KeRXY: string,
  MCSym:string,
  MCPlanetX: string,
  MCPlanetY: string,
  MCSign: string,
  MCSignSym: string,
  MCSignX: string,
  MCSignY: string,
  MCDegree: string,
  MCDegreeX: string,
  MCDegreeY: string,
  MCMinute: string,
  MCMinuteX: string,
  MCMinuteY: string,
  PlSym:string,
  PlPlanetX: string,
  PlPlanetY: string,
  PlSign: string,
  PlSignSym: string,
  PlSignX: string,
  PlSignY: string,
  PlDegree: string,
  PlDegreeX: string,
  PlDegreeY: string,
  PlMinute: string,
  PlMinuteX: string,
  PlMinuteY: string,
  PlRX: boolean,
  PlRXX: string,
  PlRXY: string,
  MaSym:string,
  MaPlanetX: string,
  MaPlanetY: string,
  MaSign: string,
  MaSignSym: string,
  MaSignX: string,
  MaSignY: string,
  MaDegree: string,
  MaDegreeX: string,
  MaDegreeY: string,
  MaMinute: string,
  MaMinuteX: string,
  MaMinuteY: string,
  MaRX: boolean,
  MaRXX: string,
  MaRXY: string,
  SaSym:string,
  SaPlanetX: string,
  SaPlanetY: string,
  SaSign: string,
  SaSignSym: string,
  SaSignX: string,
  SaSignY: string,
  SaDegree: string,
  SaDegreeX: string,
  SaDegreeY: string,
  SaMinute: string,
  SaMinuteX: string,
  SaMinuteY: string,
  SaRX: boolean,
  SaRXX: string,
  SaRXY: string,
  NeSym:string,
  NePlanetX: string,
  NePlanetY: string,
  NeSign: string,
  NeSignSym: string,
  NeSignX: string,
  NeSignY: string,
  NeDegree: string,
  NeDegreeX: string,
  NeDegreeY: string,
  NeMinute: string,
  NeMinuteX: string,
  NeMinuteY: string,
  NeRX: boolean,
  NeRXX: string,
  NeRXY: string,
  LoFoSym:string,
  LoFoPlanetX: string,
  LoFoPlanetY: string,
  LoFoSign: string,
  LoFoSignSym: string,
  LoFoSignX: string,
  LoFoSignY: string,
  LoFoDegree: string,
  LoFoDegreeX: string,
  LoFoDegreeY: string,
  LoFoMinute: string,
  LoFoMinuteX: string,
  LoFoMinuteY: string

  RXBSym: string,
  MoBPlanetX: string,
  MoBPlanetY: string,
  MoBSym:string,
  MoBSign: string,
  MoBSignSym: string,
  MoBSignX: string,
  MoBSignY: string,
  MoBDegree: string,
  MoBDegreeX: string,
  MoBDegreeY: string,
  MoBMinute: string,
  MoBMinuteX: string,
  MoBMinuteY: string,
  VeBSym:string,
  VeBPlanetX: string,
  VeBPlanetY: string,
  VeBSign: string,
  VeBSignSym: string,
  VeBSignX: string,
  VeBSignY: string,
  VeBDegree: string,
  VeBDegreeX: string,
  VeBDegreeY: string,
  VeBMinute: string,
  VeBMinuteX: string,
  VeBMinuteY: string,
  VeBRX: boolean,
  VeBRXX: string,
  VeBRXY: string,
  ASCBSym:string,
  ASCBPlanetX: string,
  ASCBPlanetY: string,
  ASCBSign: string,
  ASCBSignSym: string,
  ASCBSignX: string,
  ASCBSignY: string,
  ASCBDegree: string,
  ASCBDegreeX: string,
  ASCBDegreeY: string,
  ASCBMinute: string,
  ASCBMinuteX: string,
  ASCBMinuteY: string,
  RaBSym:string,
  RaBPlanetX: string,
  RaBPlanetY: string,
  RaBSign: string,
  RaBSignSym: string,
  RaBSignX: string,
  RaBSignY: string,
  RaBDegree: string,
  RaBDegreeX: string,
  RaBDegreeY: string,
  RaBMinute: string,
  RaBMinuteX: string,
  RaBMinuteY: string,
  RaBRX: boolean,
  RaBRXX: string,
  RaBRXY: string,
  SuBSym:string,
  SuBPlanetX: string,
  SuBPlanetY: string,
  SuBSign: string,
  SuBSignSym: string,
  SuBSignX: string,
  SuBSignY: string,
  SuBDegree: string,
  SuBDegreeX: string,
  SuBDegreeY: string,
  SuBMinute: string,
  SuBMinuteX: string,
  SuBMinuteY: string,
  ChBSym:string,
  ChBPlanetX: string,
  ChBPlanetY: string,
  ChBSign: string,
  ChBSignSym: string,
  ChBSignX: string,
  ChBSignY: string,
  ChBDegree: string,
  ChBDegreeX: string,
  ChBDegreeY: string,
  ChBMinute: string,
  ChBMinuteX: string,
  ChBMinuteY: string,
  ChBRX: boolean,
  ChBRXX: string,
  ChBRXY: string,
  MeBSym:string,
  MeBPlanetX: string,
  MeBPlanetY: string,
  MeBSign: string,
  MeBSignSym: string,
  MeBSignX: string,
  MeBSignY: string,
  MeBDegree: string,
  MeBDegreeX: string,
  MeBDegreeY: string,
  MeBMinute: string,
  MeBMinuteX: string,
  MeBMinuteY: string,
  MeBRX: boolean,
  MeBRXX: string,
  MeBRXY: string,
  JuBSym:string,
  JuBPlanetX: string,
  JuBPlanetY: string,
  JuBSign: string,
  JuBSignSym: string,
  JuBSignX: string,
  JuBSignY: string,
  JuBDegree: string,
  JuBDegreeX: string,
  JuBDegreeY: string,
  JuBMinute: string,
  JuBMinuteX: string,
  JuBMinuteY: string,
  JuBRX: boolean,
  JuBRXX: string,
  JuBRXY: string,
  UrBSym:string,
  UrBPlanetX: string,
  UrBPlanetY: string,
  UrBSign: string,
  UrBSignSym: string,
  UrBSignX: string,
  UrBSignY: string,
  UrBDegree: string,
  UrBDegreeX: string,
  UrBDegreeY: string,
  UrBMinute: string,
  UrBMinuteX: string,
  UrBMinuteY: string,
  UrBRX: boolean,
  UrBRXX: string,
  UrBRXY: string,
  ICBSym:string,
  ICBPlanetX: string,
  ICBPlanetY: string,
  ICBSign: string,
  ICBSignSym: string,
  ICBSignX: string,
  ICBSignY: string,
  ICBDegree: string,
  ICBDegreeX: string,
  ICBDegreeY: string,
  ICBMinute: string,
  ICBMinuteX: string,
  ICBMinuteY: string,
  DSCBSym:string,
  DSCBPlanetX: string,
  DSCBPlanetY: string,
  DSCBSign: string,
  DSCBSignSym: string,
  DSCBSignX: string,
  DSCBSignY: string,
  DSCBDegree: string,
  DSCBDegreeX: string,
  DSCBDegreeY: string,
  DSCBMinute: string,
  DSCBMinuteX: string,
  DSCBMinuteY: string,
  KeBSym:string,
  KeBPlanetX: string,
  KeBPlanetY: string,
  KeBSign: string,
  KeBSignSym: string,
  KeBSignX: string,
  KeBSignY: string,
  KeBDegree: string,
  KeBDegreeX: string,
  KeBDegreeY: string,
  KeBMinute: string,
  KeBMinuteX: string,
  KeBMinuteY: string,
  KeBRX: boolean,
  KeBRXX: string,
  KeBRXY: string,
  MCBSym:string,
  MCBPlanetX: string,
  MCBPlanetY: string,
  MCBSign: string,
  MCBSignSym: string,
  MCBSignX: string,
  MCBSignY: string,
  MCBDegree: string,
  MCBDegreeX: string,
  MCBDegreeY: string,
  MCBMinute: string,
  MCBMinuteX: string,
  MCBMinuteY: string,
  PlBSym:string,
  PlBPlanetX: string,
  PlBPlanetY: string,
  PlBSign: string,
  PlBSignSym: string,
  PlBSignX: string,
  PlBSignY: string,
  PlBDegree: string,
  PlBDegreeX: string,
  PlBDegreeY: string,
  PlBMinute: string,
  PlBMinuteX: string,
  PlBMinuteY: string,
  PlBRX: boolean,
  PlBRXX: string,
  PlBRXY: string,
  MaBSym:string,
  MaBPlanetX: string,
  MaBPlanetY: string,
  MaBSign: string,
  MaBSignSym: string,
  MaBSignX: string,
  MaBSignY: string,
  MaBDegree: string,
  MaBDegreeX: string,
  MaBDegreeY: string,
  MaBMinute: string,
  MaBMinuteX: string,
  MaBMinuteY: string,
  MaBRX: boolean,
  MaBRXX: string,
  MaBRXY: string,
  SaBSym:string,
  SaBPlanetX: string,
  SaBPlanetY: string,
  SaBSign: string,
  SaBSignSym: string,
  SaBSignX: string,
  SaBSignY: string,
  SaBDegree: string,
  SaBDegreeX: string,
  SaBDegreeY: string,
  SaBMinute: string,
  SaBMinuteX: string,
  SaBMinuteY: string,
  SaBRX: boolean,
  SaBRXX: string,
  SaBRXY: string,
  NeBSym:string,
  NeBPlanetX: string,
  NeBPlanetY: string,
  NeBSign: string,
  NeBSignSym: string,
  NeBSignX: string,
  NeBSignY: string,
  NeBDegree: string,
  NeBDegreeX: string,
  NeBDegreeY: string,
  NeBMinute: string,
  NeBMinuteX: string,
  NeBMinuteY: string,
  NeBRX: boolean,
  NeBRXX: string,
  NeBRXY: string,
  LoFoBSym:string,
  LoFoBPlanetX: string,
  LoFoBPlanetY: string,
  LoFoBSign: string,
  LoFoBSignSym: string,
  LoFoBSignX: string,
  LoFoBSignY: string,
  LoFoBDegree: string,
  LoFoBDegreeX: string,
  LoFoBDegreeY: string,
  LoFoBMinute: string,
  LoFoBMinuteX: string,
  LoFoBMinuteY: string,

  
}

export const BiChartSvg = ( {
  centerX = '475',
  centerY = '475',
  signRadius = '645',
  signBorderRadius = '526',
  outerRadius = '570',
  innerRadius = '380',
  houseRadius = '205',
  centerRadius = '110',
  DegreeSym = '°',
  AriSignX = '-114',
  AriSignY = '632',
  TauSignX = '43', 
  TauSignY = '906',
  GemSignX = '317',
  GemSignY = '1064',
  CanSignX = '632',
  CanSignY = '1064',
  LeoSignX = '906',
  LeoSignY = '906',
  VirSignX = '1064',
  VirSignY = '632',
  LibSignX = '1064',
  LibSignY = '317',
  ScoSignX = '906',
  ScoSignY = '43',
  SagSignX = '632',
  SagSignY = '-114',
  CapSignX = '317',
  CapSignY = '-114',
  AquSignX = '43',
  AquSignY = '43',
  PisSignX = '-114',
  PisSignY = '317',
  RXSym = 'M',
  MoPlanetX = '141',
  MoPlanetY = '338',
  MoSym = 'R',
  MoSign = 'Pis',
  MoSignSym = 'L',
  MoSignX = '206',
  MoSignY = '365',
  MoDegree = '5',
  MoDegreeX = '178',
  MoDegreeY = '353',
  MoMinute = '15',
  MoMinuteX = '234',
  MoMinuteY = '376',
  VePlanetX = '234',
  VePlanetY = '207',
  VeSym = 'T',
  VeSign = 'Aqu',
  VeSignSym = 'K',
  VeSignX = '281',
  VeSignY = '259',
  VeDegree = '12',
  VeDegreeX = '261',
  VeDegreeY = '237',
  VeMinute = '7',
  VeMinuteX = '301',
  VeMinuteY = '281',
  VeRX = false,
  VeRXX = '0',
  VeRXY = '0',
  ASCSym= 'a',
  ASCPlanetX = '123',
  ASCPlanetY = '551',
  ASCSign = 'Ari',
  ASCSignSym = 'A',
  ASCSignX = '191',
  ASCSignY = '536',
  ASCDegree = '13',
  ASCDegreeX = '162',
  ASCDegreeY = '542',
  ASCMinute = '20',
  ASCMinuteX = '220',
  ASCMinuteY = '529',
  RaSym='<',
  RaPlanetX = '744',
  RaPlanetY = '236',
  RaSign = 'Sco',
  RaSignSym = 'H',
  RaSignX = '691',
  RaSignY = '282',
  RaDegree = '15',
  RaDegreeX = '714',
  RaDegreeY = '262',
  RaMinute = '38',
  RaMinuteX = '669',
  RaMinuteY = '302',
  RaRX = true,
  RaRXX = '643',
  RaRXY = '325',
  SuSym = 'Q',
  SuPlanetX = '132',
  SuPlanetY = '364',
  SuSign = 'Pis',
  SuSignSym = 'L',
  SuSignX = '199',
  SuSignY = '385',
  SuDegree = '10',
  SuDegreeX = '170',
  SuDegreeY = '376',
  SuMinute = '5',
  SuMinuteX = '227',
  SuMinuteY = '394',
  ChSym = 't',
  ChPlanetX = '157',
  ChPlanetY = '643',
  ChSign = 'Ari',
  ChSignSym = 'A',
  ChSignX = '218',
  ChSignY = '611',
  ChDegree = '24',
  ChDegreeX = '192',
  ChDegreeY = '625',
  ChMinute = '59',
  ChMinuteX = '245',
  ChMinuteY = '596',
  ChRX = false,
  ChRXX = '0',
  ChRXY = '0',
  MeSym = 'S',
  MePlanetX = '214',
  MePlanetY = '226',
  MeSign = 'Aqu',
  MeSignSym = 'K',
  MeSignX = '265',
  MeSignY = '274',
  MeDegree = '16',
  MeDegreeX = '243',
  MeDegreeY = '253',
  MeMinute = '39',
  MeMinuteX = '287',
  MeMinuteY = '295',
  MeRX = false,
  MeRXX = '0',
  MeRXY = '0',
  JuSym = 'V',
  JuPlanetX = '141',
  JuPlanetY = '611',
  JuSign = 'Ari',
  JuSignSym = 'A',
  JuSignX = '206',
  JuSignY = '584',
  JuDegree = '24',
  JuDegreeX = '178',
  JuDegreeY = '596',
  JuMinute = '20',
  JuMinuteX = '234',
  JuMinuteY = '573',
  JuRX = false,
  JuRXX = '0',
  JuRXY = '0',  
  UrSym = 'X',
  UrPlanetX = '761',
  UrPlanetY = '256',
  UrSign = 'Sco',
  UrSignSym = 'H',
  UrSignX = '705',
  UrSignY = '299',
  UrDegree = '6',
  UrDegreeX = '729',
  UrDegreeY = '281',
  UrMinute = '59',
  UrMinuteX = '681',
  UrMinuteY = '317',
  UrRX = true,
  UrRXX = '654',
  UrRXY = '338',
  ICSym= '',
  ICPlanetX = '526',
  ICPlanetY = '831',
  ICSign = 'Can',
  ICSignSym = '',
  ICSignX = '516',
  ICSignY = '762',
  ICDegree = '',
  ICDegreeX = '529',
  ICDegreeY = '791',
  ICMinute = '',
  ICMinuteX = '512',
  ICMinuteY = '732',
  DSCSym = 'DC',
  DSCPlanetX = '821',
  DSCPlanetY = '377',
  DSCSign = 'Lib',
  DSCSignSym = 'G',
  DSCSignX = '754',
  DSCSignY = '396',
  DSCDegree = '13',
  DSCDegreeX = '782',
  DSCDegreeY = '387',
  DSCMinute = '20',
  DSCMinuteX = '725',
  DSCMinuteY = '404',
  KeSym = '>',
  KePlanetX = '208',
  KePlanetY = '717',
  KeSign = 'Tau',
  KeSignSym = 'B',
  KeSignX = '260',
  KeSignY = '670',
  KeDegree = '14',
  KeDegreeX = '238',
  KeDegreeY = '690',
  KeMinute = '43',
  KeMinuteX = '282',
  KeMinuteY = '650',
  KeRX = true,
  KeRXX = '308',
  KeRXY = '626',
  MCSym = 'b',
  MCPlanetX = '427',
  MCPlanetY = '118',
  MCSign = 'Cap',
  MCSignSym = 'J',
  MCSignX = '437',
  MCSignY = '187',
  MCDegree = '6',
  MCDegreeX = '433',
  MCDegreeY = '157',
  MCMinute = '44',
  MCMinuteX = '440',
  MCMinuteY = '217',
  PlSym = 'Z',
  PlPlanetX = '827',
  PlPlanetY = '403',
  PlSign = 'Lib',
  PlSignSym = 'G',
  PlSignX = '759',
  PlSignY = '417',
  PlDegree = '11',
  PlDegreeX = '788',
  PlDegreeY = '411',
  PlMinute = '8',
  PlMinuteX = '729',
  PlMinuteY = '423',
  PlRX = true,
  PlRXX = '695',
  PlRXY = '430',
  MaSym = 'U',
  MaPlanetX = '427',
  MaPlanetY = '831',
  MaSign = 'Gem',
  MaSignSym = 'C',
  MaSignX = '437',
  MaSignY = '762',
  MaDegree = '22',
  MaDegreeX = '433',
  MaDegreeY = '792',
  MaMinute = '48',
  MaMinuteX = '440',
  MaMinuteY = '732',
  MaRX = false,
  MaRXX = '0',
  MaRXY = '0',
  SaSym = 'W',
  SaPlanetX = '645',
  SaPlanetY = '791',
  SaSign = 'Can',
  SaSignSym = 'D',
  SaSignX = '612',
  SaSignY = '730',
  SaDegree = '26',
  SaDegreeX = '626',
  SaDegreeY = '756',
  SaMinute = '42',
  SaMinuteX = '598',
  SaMinuteY = '703',
  SaRX = true,
  SaRXX = '581',
  SaRXY = '673',
  NeSym = 'Y',
  NePlanetX = '587',
  NePlanetY = '133',
  NeSign = 'Sag',
  NeSignSym = 'I',
  NeSignX = '565',
  NeSignY = '199',
  NeDegree = '13',
  NeDegreeX = '575',
  NeDegreeY = '171',
  NeMinute = '54',
  NeMinuteX = '556',
  NeMinuteY = '228',
  NeRX = false,
  NeRXX = '0',
  NeRXY = '0',
  LoFoSym = ';',
  LoFoPlanetX = '227',
  LoFoPlanetY = '736',
  LoFoSign = 'Can',
  LoFoSignSym = 'D',
  LoFoSignX = '275',
  LoFoSignY = '685',
  LoFoDegree = '12',
  LoFoDegreeX = '255',
  LoFoDegreeY = '707',
  LoFoMinute = '42',
  LoFoMinuteX = '296',
  LoFoMinuteY = '663',
  RXBSym = 'M',
  MoBPlanetX = '25',
  MoBPlanetY = '503',
  MoBSym = 'R',
  MoBSign = 'Ari',
  MoBSignSym = 'A',
  MoBSignX = '110',
  MoBSignY = '497',
  MoBDegree = '1',
  MoBDegreeX = '75',
  MoBDegreeY = '500',
  MoBMinute = '22',
  MoBMinuteX = '140',
  MoBMinuteY = '495',
  VeBPlanetX = '29',
  VeBPlanetY = '536',
  VeBSym = 'T',
  VeBSign = 'Ari',
  VeBSignSym = 'A',
  VeBSignX = '113',
  VeBSignY = '525',
  VeBDegree = '2',
  VeBDegreeX = '78',
  VeBDegreeY = '529',
  VeBMinute = '58',
  VeBMinuteX = '143',
  VeBMinuteY = '520',
  VeBRX = false,
  VeBRXX = '0',
  VeBRXY = '0',
  ASCBSym= 'a',
  ASCBPlanetX = '35',
  ASCBPlanetY = '570',
  ASCBSign = 'Ari',
  ASCBSignSym = 'A',
  ASCBSignX = '118',
  ASCBSignY = '552',
  ASCBDegree = '14',
  ASCBDegreeX = '84',
  ASCBDegreeY = '559',
  ASCBMinute = '47',
  ASCBMinuteX = '147',
  ASCBMinuteY = '545',
  RaBSym = '<',
  RaBPlanetX = '43',
  RaBPlanetY = '602',
  RaBSign = 'Ari',
  RaBSignSym = 'A',
  RaBSignX = '125',
  RaBSignY = '578',
  RaBDegree = '15',
  RaBDegreeX = '91',
  RaBDegreeY = '588',
  RaBMinute = '38',
  RaBMinuteX = '153',
  RaBMinuteY = '570',
  RaBRX = true,
  RaBRXX = '0',
  RaBRXY = '0',
  SuBSym = 'Q',
  SuBPlanetX = '54',
  SuBPlanetY = '634',
  SuBSign = 'Ari',
  SuBSignSym = 'A',
  SuBSignX = '133',
  SuBSignY = '604',
  SuBDegree = '18',
  SuBDegreeX = '101',
  SuBDegreeY = '617',
  SuBMinute = '13',
  SuBMinuteX = '161',
  SuBMinuteY = '593',
  ChBSym = 't',
  ChBPlanetX = '67',
  ChBPlanetY = '665',
  ChBSign = 'Ari',
  ChBSignSym = 'A',
  ChBSignX = '144',
  ChBSignY = '629',
  ChBDegree = '19',
  ChBDegreeX = '112',
  ChBDegreeY = '644',
  ChBMinute = '20',
  ChBMinuteX = '171',
  ChBMinuteY = '617',
  ChBRX = false,
  ChBRXX = '0',
  ChBRXY = '0',
  MeBSym = 'S',
  MeBPlanetX = '82',
  MeBPlanetY = '695',
  MeBSign = 'Ari',
  MeBSignSym = 'A',
  MeBSignX = '157',
  MeBSignY = '654',
  MeBDegree = '25',
  MeBDegreeX = '126',
  MeBDegreeY = '671',
  MeBMinute = '31',
  MeBMinuteX = '183',
  MeBMinuteY = '639',
  MeBRX = true,
  MeBRXX = '209',
  MeBRXY = '624',
  JuBSym = 'V',
  JuBPlanetX = '165',
  JuBPlanetY = '802',
  JuBSign = 'Tau',
  JuBSignSym = 'B',
  JuBSignX = '224',
  JuBSignY = '740',
  JuBDegree = '18',
  JuBDegreeX = '200',
  JuBDegreeY = '765',
  JuBMinute = '47',
  JuBMinuteX = '244',
  JuBMinuteY = '718',
  JuBRX = false,
  JuBRXX = '0',
  JuBRXY = '0',
  UrBSym = 'X',
  UrBPlanetX = '200',
  UrBPlanetY = '831',
  UrBSign = 'Tau',
  UrBSignSym = 'B',
  UrBSignX = '252',
  UrBSignY = '763',
  UrBDegree = '21',
  UrBDegreeX = '230',
  UrBDegreeY = '791',
  UrBMinute = '7',
  UrBMinuteX = '270',
  UrBMinuteY = '740',
  UrBRX = false,
  UrBRXX = '0',
  UrBRXY = '0',
  ICBSym= 'c',
  ICBPlanetX = '539',
  ICBPlanetY = '920',
  ICBSign = 'Can',
  ICBSignSym = 'D',
  ICBSignX = '527',
  ICBSignY = '836',
  ICBDegree = '7',
  ICBDegreeX = '532',
  ICBDegreeY = '870',
  ICBMinute = '1',
  ICBMinuteX = '523',
  ICBMinuteY = '806',
  DSCBSym = 'DC',
  DSCBPlanetX = '916',
  DSCBPlanetY = '385',
  DSCBSign = 'Lib',
  DSCBSignSym = 'G',
  DSCBSignX = '832',
  DSCBSignY = '402',
  DSCBDegree = '14',
  DSCBDegreeX = '867',
  DSCBDegreeY = '395',
  DSCBMinute = '47',
  DSCBMinuteX = '803',
  DSCBMinuteY = '408',
  KeBSym = '>',
  KeBPlanetX = '908',
  KeBPlanetY = '352',
  KeBSign = 'Lib',
  KeBSignSym = 'G',
  KeBSignX = '826',
  KeBSignY = '375',
  KeBDegree = '15',
  KeBDegreeX = '859',
  KeBDegreeY = '366',
  KeBMinute = '38',
  KeBMinuteX = '797',
  KeBMinuteY = '383',
  KeBRX = true,
  KeBRXX = '0',
  KeBRXY = '0',
  MCBSym = 'b',
  MCBPlanetX = '416',
  MCBPlanetY = '28',
  MCBSign = 'Cap',
  MCBSignSym = 'J',
  MCBSignX = '427',
  MCBSignY = '113',
  MCBDegree = '7',
  MCBDegreeX = '422',
  MCBDegreeY = '78',
  MCBMinute = '1',
  MCBMinuteX = '431',
  MCBMinuteY = '142',
  PlBSym = 'Z',
  PlBPlanetX = '227',
  PlBPlanetY = '99',
  PlBSign = 'Aqu',
  PlBSignSym = 'K',
  PlBSignX = '274',
  PlBSignY = '170',
  PlBDegree = '1',
  PlBDegreeX = '255',
  PlBDegreeY = '140',
  PlBMinute = '57',
  PlBMinuteX = '290',
  PlBMinuteY = '195',
  PlBRX = false,
  PlBRXX = '0',
  PlBRXY = '0',
  MaBSym = 'U',
  MaBPlanetX = '46',
  MaBPlanetY = '336',
  MaBSign = 'Pis',
  MaBSignSym = 'L',
  MaBSignX = '127',
  MaBSignY = '362',
  MaBDegree = '12',
  MaBDegreeX = '94',
  MaBDegreeY = '351',
  MaBMinute = '7',
  MaBMinuteX = '156',
  MaBMinuteY = '371',
  MaBRX = false,
  MaBRXX = '0',
  MaBRXY = '0',
  SaBSym = 'W',
  SaBPlanetX = '37',
  SaBPlanetY = '368',
  SaBSign = 'Pis',
  SaBSignSym = 'L',
  SaBSignX = '120',
  SaBSignY = '389',
  SaBDegree = '14',
  SaBDegreeX = '86',
  SaBDegreeY = '380',
  SaBMinute = '20',
  SaBMinuteX = '149',
  SaBMinuteY = '396',
  SaBRX = false,
  SaBRXX = '0',
  SaBRXY = '0',
  NeBSym = 'Y',
  NeBPlanetX = '25',
  NeBPlanetY = '458',
  NeBSign = 'Pis',
  NeBSignSym = 'L',
  NeBSignX = '110',
  NeBSignY = '461',
  NeBDegree = '28',
  NeBDegreeX = '75',
  NeBDegreeY = '459',
  NeBMinute = '9',
  NeBMinuteX = '140',
  NeBMinuteY = '462',
  NeBRX = false,
  NeBRXX = '0',
  NeBRXY = '0',
  LoFoBSym = ';',
  LoFoBPlanetX = '71',
  LoFoBPlanetY = '841',
  LoFoBSign = 'Can',
  LoFoBSignSym = 'D',
  LoFoBSignX = '134',
  LoFoBSignY = '784',
  LoFoBDegree = '12',
  LoFoBDegreeX = '108',
  LoFoBDegreeY = '808',
  LoFoBMinute = '42',
  LoFoBMinuteX = '157',
  LoFoBMinuteY = '764'
  
 
}: Props
  ) => (
  //props: SVGProps<SVGSVGElement> 
  <svg viewBox="-175, -175, 1300, 1300" className="bi-chart" >
    {/* {...props}  */}
    <circle
      id="sign-ring"
      className="sign-ring"
      fill="currentColor"
      cx={centerX}
      cy={centerY}
      r={signRadius}
    />
    <g id="sign-ring" className="sign-ring__content">
    <text
        id="Ari-sign"
        fill="currentColor"
        x={AriSignX}
        y={AriSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + AriSignX + ',' + AriSignY + ')'}
      >
        {"A"}
      </text>
      <text
        id="Tau-sign"
        fill="currentColor"
        x={TauSignX}
        y={TauSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + TauSignX + ',' + TauSignY+ ')'}
      >
        {"B"}
      </text>
      <text
        id="Gem-sign"
        fill="currentColor"
        x={GemSignX}
        y={GemSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + GemSignX+ ',' + GemSignY + ')'}
      >
        {"C"}
      </text>
      <text
        id="Can-sign"
        fill="currentColor"
        x={CanSignX}
        y={CanSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + CanSignX + ',' + CanSignY + ')'}
        >
        {"D"}
      </text>
      <text
        id="Leo-sign"
        fill="currentColor"
        x={LeoSignX}
        y={LeoSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + LeoSignX + ',' + LeoSignY + ')'}
        >
        {"E"}
        </text>
        <text
        id="Vir-sign"
        fill="currentColor"
        x={VirSignX}
        y={VirSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + VirSignX + ',' + VirSignY + ')'}
        >
        {"F"}
        </text>
        <text
        id="Lib-sign"
        fill="currentColor"
        x={LibSignX}
        y={LibSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + LibSignX + ',' + LibSignY + ')'}
        >
        {"G"}
        </text>
        <text
        id="Sco-sign"
        fill="currentColor"
        x={ScoSignX}
        y={ScoSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + ScoSignX + ',' + ScoSignY + ')'}
        >
        {"H"}
        </text>
        <text
        id="Sag-sign"
        fill="currentColor"
        x={SagSignX}
        y={SagSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + SagSignX + ',' + SagSignY + ')'}
        >
        {"I"}
      </text>
      <text
        id="Cap-sign"
        fill="currentColor"
        x={CapSignX}
        y={CapSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + CapSignX + ',' + CapSignY + ')'}
        >
        {"J"}
      </text>
      <text
        id="Aqu-sign"
        fill="currentColor"
        x={AquSignX}
        y={AquSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + AquSignX + ',' + AquSignY + ')'}
        >
        {"K"}
      </text>
      <text
        id="Pis-sign"
        fill="currentColor"
        x={PisSignX}
        y={PisSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + PisSignX + ',' + PisSignY + ')'}
        >
        {"L"}
      </text>
    </g>
    <circle
      id="planet-ring"
      className="planet-ring"
      fill="currentColor"
      cx={centerX}
      cy={centerY}
      r={outerRadius}
    />
        <circle
      id="planet-ring"
      className="planet-ring"
      fill="currentColor"
      cx={centerX}
      cy={centerY}
      r={innerRadius}
    />

  <g id="axes" className="axes">
    <path id="1-axis" className="1-axis" d="M375 475 L-170 475 Z" />
    <path id="2-axis" className="2-axis" d="M388 525 L-83 797 Z" />
    <path id="3-axis" className="3-axis" d="M425 561 L152 1033 Z" />
    <path id="4-axis" className="4-axis" d="M475 575 L475 1120 Z" />
    <path id="5-axis" className="5-axis" d="M525 561 L797 1033 Z" />
    <path id="6-axis" className="6-axis" d="M561 525 L1033 797 Z" />
    <path id="7-axis" className="7-axis" d="M575 475 L1120 475 Z" />
    <path id="8-axis" className="8-axis" d="M561 425 L1033 152 Z" />
    <path id="9-axis" className="9-axis" d="M525 388 L797 -83 Z" />
    <path id="10-axis" className="10-axis" d="M475 375 L475 -170 Z" />
    <path id="11-axis" className="11-axis" d="M425 388 L152 -83 Z" />
    <path id="12-axis" className="12-axis" d="M388 425 L-83 152 Z" />
  </g>

  <circle
    id="house-ring"
    className="house-ring"
    fill="currentColor"
    cx={centerX}
    cy={centerY}
    r={houseRadius}
    />
    <circle
    id="center-ring"
    className="center-ring"
    fill="currentColor"
    cx={centerX}
    cy={centerY}
    r={centerRadius}
    />

        <g id="axes" className="house-axes">
        <path id="1-axis" className="1-axis" d="M420 475 L270 475 Z" />
        <path id="2-axis" className="2-axis" d="M427 502 L297 577 Z" />
        <path id="3-axis" className="3-axis" d="M447 522 L372 652 Z" />
        <path id="4-axis" className="4-axis" d="M475 530 L475 680 Z" />
        <path id="5-axis" className="5-axis" d="M502 522 L577 652 Z" />
        <path id="6-axis" className="6-axis" d="M522 502 L652 577 Z" />
        <path id="7-axis" className="7-axis" d="M530 475 L680 475 Z" />
        <path id="8-axis" className="8-axis" d="M522 447 L652 372 Z" />
        <path id="9-axis" className="9-axis" d="M502 427 L577 297 Z" />
        <path id="10-axis" className="10-axis" d="M475 420 L475 270 Z" />
        <path id="11-axis" className="11-axis" d="M447 427 L372 297 Z" />
        <path id="12-axis" className="12-axis" d="M427 447 L297 372 Z" />
        </g>
        <g id="house numbers" className="house-ring__content">
        <text id="house-1"
        fill="currentColor"
        x="320"
        y="516"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,312,518)"
        >
        {"1"}
        </text>
        <text id="house-2"
        fill="currentColor"
        x="361"
        y="588"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,356,593)"
        >
        {"2"}
        </text>
        <text id="house-3"
        fill="currentColor"
        x="433"
        y="629"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,431,637)"
        >
        {"3"}
        </text>
        <text id="house-4"
        fill="currentColor"
        x="516"
        y="629"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,518,637)"
        >
        {"4"}
        </text>
        <text id="house-5"
        fill="currentColor"
        x="588"
        y="588"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,593,593)"
        >
        {"5"}
        </text>
        <text id="house-6"
        fill="currentColor"
        x="629"
        y="516"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,637,518)"
        >
        {"6"}
        </text>
        <text id="house-7"
        fill="currentColor"
        x="629"
        y="433"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,637,431)"
        >
        {"7"}
        </text>
        <text id="house-8"
        fill="currentColor"
        x="588"
        y="361"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,593,356)"
        >
        {"8"}
        </text>
        <text id="house-9"
        fill="currentColor"
        x="516"
        y="320"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,518,312)"
        >
        {"9"}
        </text>
        <text id="house-10"
        fill="currentColor"
        x="433"
        y="320"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,431,312)"
        >
        {"10"}
        </text>
        <text id="house-11"
        fill="currentColor"
        x="361"
        y="361"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,356,356)"
        >
        {"11"}
        </text>
        <text id="house-12"
        fill="currentColor"
        x="320"
        y="431"
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,312,431)"
        >
        {"12"}
        </text>
        </g>

        <g className="planet-ring__content--inner">
        <g id="Mo-p-group-inner">
        <text
                id="Mo-planet-inner"
                className="Mo planet-ring__planet--inner"
                fill="currentColor"
                x={MoPlanetX}
                y={MoPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoPlanetX==null ? '0' : MoPlanetX + ',' + MoPlanetY==null ? '0' : MoPlanetY + ')'}
                >
                {MoSym}
        </text>
        <text
                id="Mo-sign-inner"
                className={MoSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={MoSignX}
                y={MoSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoSignX==null ? '0' : MoSignX + ',' + MoSignY==null ? '0' : MoSignY + ')'}
                >
                {MoSignSym}
        </text>
        <text
                id="Mo-degree-inner"
                className={"planet-ring__degree--inner"}
                fill="currentColor"
                x={MoDegreeX}
                y={MoDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoDegreeX + ',' + MoDegreeY + ')'}
                >
                {MoDegree}{MoDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Mo-minute-inner"
                className={"planet-ring__minute--inner"}
                fill="currentColor"
                x={MoMinuteX}
                y={MoMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoMinuteX + ',' + MoMinuteY + ')'}
                >
                {MoMinute}
        </text>
        </g>
        <g id="Ve-p-group-inner">
        <text
                id="Ve-planet-inner"
                className="Ve planet-ring__planet--inner"
                fill="currentColor"
                x={VePlanetX}
                y={VePlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VePlanetX + ',' + VePlanetY + ')'}
                >
                {VeSym}
        </text>
        <text
                id="Ve-sign-inner"
                className={VeSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={VeSignX}
                y={VeSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeSignX + ',' + VeSignY + ')'}
                >
                {VeSignSym}
        </text>
        <text
                id="Ve-degree-inner"
                className={VeRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={VeDegreeX}
                y={VeDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeDegreeX + ',' + VeDegreeY + ')'}
                >
                {VeDegree}{VeDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ve-minute-inner"
                className={VeRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={VeMinuteX}
                y={VeMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeMinuteX + ',' + VeMinuteY + ')'}
                >
                {VeMinute}
        </text>
                {VeRX === false ? null: <text
                id="Ve-rx-inner"
                className="Ve planet-ring__planet--inner rx"
                fill="currentColor"
                x={VeRXX}
                y={VeRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeRXX + ',' + VeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="ASC-p-group-inner">
        <text
                id="ASC-planet-inner"
                className="ASC planet-ring__planet--inner"
                fill="currentColor"
                x={ASCPlanetX}
                y={ASCPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCPlanetX + ',' + ASCPlanetY + ')'}
                >
                {ASCSym}
        </text>
        <text
                id="ASC-sign-inner"
                className={ASCSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={ASCSignX}
                y={ASCSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCSignX + ',' + ASCSignY + ')'}
                >
                {ASCSignSym}
        </text>
        <text
                id="ASC-degree-inner"
                className={"planet-ring__degree--inner"}
                fill="currentColor"
                x={ASCDegreeX}
                y={ASCDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCDegreeX + ',' + ASCDegreeY + ')'}
                >
                {ASCDegree}{ASCDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="ASC-minute-inner"
                className={"planet-ring__minute--inner"}
                fill="currentColor"
                x={ASCMinuteX}
                y={ASCMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCMinuteX + ',' + ASCMinuteY + ')'}
                >
                {ASCMinute}
        </text>
        </g>
        <g id="Ra-p-group-inner">
        <text
                id="Ra-planet-inner"
                className="Ra planet-ring__planet--inner"
                fill="currentColor"
                x={RaPlanetX}
                y={RaPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaPlanetX + ',' + RaPlanetY + ')'}
                >
                {RaSym}
        </text>
        <text
                id="Ra-sign-inner"
                className={RaSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={RaSignX}
                y={RaSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaSignX + ',' + RaSignY + ')'}
                >
                {RaSignSym}
        </text>
        <text
                id="Ra-degree-inner"
                className={RaRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={RaDegreeX}
                y={RaDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaDegreeX + ',' + RaDegreeY + ')'}
                >
                {RaDegree}{RaDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ra-minute-inner"
                className={RaRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={RaMinuteX}
                y={RaMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaMinuteX + ',' + RaMinuteY + ')'}
                >
                {RaMinute}
        </text>
                {RaRX === false ? null: <text
                id="Ra-rx-inner"
                className="Ra planet-ring__planet--inner rx"
                fill="currentColor"
                x={RaRXX}
                y={RaRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaRXX + ',' + RaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Su-p-group-inner">
        <text
                id="Su-planet-inner"
                className="Su planet-ring__planet--inner"
                fill="currentColor"
                x={SuPlanetX}
                y={SuPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuPlanetX + ',' + SuPlanetY + ')'}
                >
                {SuSym}
        </text>
        <text
                id="Su-sign-inner"
                className={SuSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={SuSignX}
                y={SuSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuSignX + ',' + SuSignY + ')'}
                >
                {SuSignSym}
        </text>
        <text
                id="Su-degree-inner"
                className={"planet-ring__degree--inner"}
                fill="currentColor"
                x={SuDegreeX}
                y={SuDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuDegreeX + ',' + SuDegreeY + ')'}
                >
                {SuDegree}{SuDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Su-minute-inner"
                className={"planet-ring__minute--inner"}
                fill="currentColor"
                x={SuMinuteX}
                y={SuMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuMinuteX + ',' + SuMinuteY + ')'}
                >
                {SuMinute}
        </text>
        </g>
        <g id="Ch-p-group-inner">
        <text
                id="Ch-planet-inner"
                className="Ch planet-ring__planet--inner"
                fill="currentColor"
                x={ChPlanetX}
                y={ChPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChPlanetX + ',' + ChPlanetY + ')'}
                >
                {ChSym}
        </text>
        <text
                id="Ch-sign-inner"
                className={ChSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={ChSignX}
                y={ChSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChSignX + ',' + ChSignY + ')'}
                >
                {ChSignSym}
        </text>
        <text
                id="Ch-degree-inner"
                className={ChRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={ChDegreeX}
                y={ChDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChDegreeX + ',' + ChDegreeY + ')'}
                >
                {ChDegree}{ChDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ch-minute-inner"
                className={ChRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={ChMinuteX}
                y={ChMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChMinuteX + ',' + ChMinuteY + ')'}
                >
                {ChMinute}
        </text>
                {ChRX === false ? null : <text
                id="Ch-rx inner"
                className="Ch planet-ring__planet--inner rx"
                fill="currentColor"
                x={ChRXX}
                y={ChRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChRXX + ',' + ChRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Me-p-group-inner">
        <text
                id="Me-planet-inner"
                className="Me planet-ring__planet--inner"
                fill="currentColor"
                x={MePlanetX}
                y={MePlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MePlanetX + ',' + MePlanetY + ')'}
                >
                {MeSym}
        </text>
        <text
                id="Me-sign-inner"
                className={MeSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={MeSignX}
                y={MeSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeSignX + ',' + MeSignY + ')'}
                >
                {MeSignSym}
        </text>
        <text
                id="Me-degree-inner"
                className={MeRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={MeDegreeX}
                y={MeDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeDegreeX + ',' + MeDegreeY + ')'}
                >
                {MeDegree}{MeDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Me-minute-inner"
                className={MeRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={MeMinuteX}
                y={MeMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeMinuteX + ',' + MeMinuteY + ')'}
                >
                {MeMinute}
        </text>
                {MeRX === false ? null : <text
                id="Me-rx-inner"
                className="Me planet-ring__planet--inner rx"
                fill="currentColor"
                x={MeRXX}
                y={MeRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeRXX + ',' + MeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ju-p-group-inner">
        <text
                id="Ju-planet-inner"
                className="Ju planet-ring__planet--inner"
                fill="currentColor"
                x={JuPlanetX}
                y={JuPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuPlanetX + ',' + JuPlanetY + ')'}
                >
                {JuSym}
        </text>
        <text
                id="Ju-sign-inner"
                className={JuSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={JuSignX}
                y={JuSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuSignX + ',' + JuSignY + ')'}
                >
                {JuSignSym}
        </text>
        <text
                id="Ju-degree-inner"
                className={JuRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={JuDegreeX}
                y={JuDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuDegreeX + ',' + JuDegreeY + ')'}
                >
                {JuDegree}{JuDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ju-minute-inner"
                className={MeRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={JuMinuteX}
                y={JuMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuMinuteX + ',' + JuMinuteY + ')'}
                >
                {JuMinute}
        </text>
                {JuRX === false ? null : <text
                id="Ju-rx-inner"
                className="Ju planet-ring__planet--inner rx"
                fill="currentColor"
                x={JuRXX}
                y={JuRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuRXX + ',' + JuRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ur-p-group-inner">
        <text
                id="Ur-planet-inner"
                className="Ur planet-ring__planet--inner"
                fill="currentColor"
                x={UrPlanetX}
                y={UrPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrPlanetX + ',' + UrPlanetY + ')'}
                >
                {UrSym}
        </text>
        <text
                id="Ur-sign-inner"
                className={UrSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={UrSignX}
                y={UrSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrSignX + ',' + UrSignY + ')'}
                >
                {UrSignSym}
        </text>
        <text
                id="Ur-degree-inner"
                className={UrRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={UrDegreeX}
                y={UrDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrDegreeX + ',' + UrDegreeY + ')'}
                >
                {UrDegree}{UrDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ur-minute-inner"
                className={UrRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={UrMinuteX}
                y={UrMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrMinuteX + ',' + UrMinuteY + ')'}
                >
                {UrMinute}
        </text>
                {UrRX === false ? null : <text
                id="Ur-rx-inner"
                className="Ur planet-ring__planet--inner rx"
                fill="currentColor"
                x={UrRXX}
                y={UrRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrRXX + ',' + UrRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="IC-p-group-inner">
        <text
                id="IC-planet"
                className="IC planet-ring__planet--inner"
                fill="currentColor"
                x={ICPlanetX}
                y={ICPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICPlanetX + ',' + ICPlanetY + ')'}
                >
                {ICSym}
        </text>
        <text
                id="IC-sign-inner"
                className={ICSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={ICSignX}
                y={ICSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICSignX + ',' + ICSignY + ')'}
                >
                {ICSignSym}
        </text>
        <text
                id="IC-degree-inner"
                className="IC planet-ring__degree--inner"
                fill="currentColor"
                x={ICDegreeX}
                y={ICDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICDegreeX + ',' + ICDegreeY + ')'}
                >
                {ICDegree}{ICDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="IC-minute-inner"
                className="IC planet-ring__minute--inner"
                fill="currentColor"
                x={ICMinuteX}
                y={ICMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICMinuteX + ',' + ICMinuteY + ')'}
                >
                {ICMinute}
        </text>
        </g>
        <g id="DSC-p-group-inner">
        <text
                id="DSC-planet-inner"
                className="DSC planet-ring__planet--inner"
                fill="currentColor"
                x={DSCPlanetX}
                y={DSCPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCPlanetX + ',' + DSCPlanetY + ')'}
                >
                {DSCSym}
        </text>
        <text
                id="DSC-sign-inner"
                className={DSCSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={DSCSignX}
                y={DSCSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCSignX + ',' + DSCSignY + ')'}
                >
                {DSCSignSym}
        </text>
        <text
                id="DSC-degree-inner"
                className="IC planet-ring__degree--inner"
                fill="currentColor"
                x={DSCDegreeX}
                y={DSCDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCDegreeX + ',' + DSCDegreeY + ')'}
                >
                {DSCDegree}{DSCDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="DSC-minute"
                className="IC planet-ring__minute--inner"
                fill="currentColor"
                x={DSCMinuteX}
                y={DSCMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCMinuteX + ',' + DSCMinuteY + ')'}
                >
                {DSCMinute}
        </text>
        </g>
        <g id="Ke-p-group-inner">
        <text
                id="Ke-planet"
                className="Ke planet-ring__planet--inner"
                fill="currentColor"
                x={KePlanetX}
                y={KePlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KePlanetX + ',' + KePlanetY + ')'}
                >
                {KeSym}
        </text>
        <text
                id="Ke-sign-inner"
                className={KeSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={KeSignX}
                y={KeSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeSignX + ',' + KeSignY + ')'}
                >
                {KeSignSym}
        </text>
        <text
                id="Ke-degree-inner"
                className={KeRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={KeDegreeX}
                y={KeDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeDegreeX + ',' + KeDegreeY + ')'}
                >
                {KeDegree}{KeDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ke-minute-inner"
                className={KeRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"} 
                fill="currentColor"
                x={KeMinuteX}
                y={KeMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeMinuteX + ',' + KeMinuteY + ')'}
                >
                {KeMinute}
        </text>
                {KeRX === false ? null : <text
                id="Ke-rx-inner"
                className="Ke planet-ring__planet--inner rx"
                fill="currentColor"
                x={KeRXX}
                y={KeRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeRXX + ',' + KeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="MC-p-group-inner">
        <text
                id="MC-planet-inner"
                className="MC planet-ring__planet--inner"
                fill="currentColor"
                x={MCPlanetX}
                y={MCPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCPlanetX + ',' + MCPlanetY + ')'}
                >
                {MCSym}
        </text>
        <text
                id="MC-sign-inner"
                className={MCSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={MCSignX}
                y={MCSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCSignX + ',' + MCSignY + ')'}
                >
                {MCSignSym}
        </text>
        <text
                id="MC-degree-inner"
                className={"planet-ring__degree--inner"}
                fill="currentColor"
                x={MCDegreeX}
                y={MCDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCDegreeX + ',' + MCDegreeY + ')'}
                >
                {MCDegree}{MCDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="MC-minute-inner"
                className={"planet-ring__minute--inner"}
                fill="currentColor"
                x={MCMinuteX}
                y={MCMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCMinuteX + ',' + MCMinuteY + ')'}
                >
                {MCMinute}
        </text>
        </g>
        <g id="Pl-p-group-inner">
        <text
                id="Pl-planet-inner"
                className="Pl planet-ring__planet--inner"
                fill="currentColor"
                x={PlPlanetX}
                y={PlPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlPlanetX + ',' + PlPlanetY + ')'}
                >
                {PlSym}
        </text>
        <text
                id="Pl-sign-inner"
                className={PlSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={PlSignX}
                y={PlSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlSignX + ',' + PlSignY + ')'}
                >
                {PlSignSym}
        </text>
        <text
                id="Pl-degree-inner"
                className={PlRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={PlDegreeX}
                y={PlDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlDegreeX + ',' + PlDegreeY + ')'}
                >
                {PlDegree}{PlDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Pl-minute-inner"
                className={PlRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={PlMinuteX}
                y={PlMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlMinuteX + ',' + PlMinuteY + ')'}
                >
                {PlMinute}
        </text>
                {PlRX === false ? null : <text
                id="Pl-rx-inner"
                className="Pl planet-ring__planet--inner rx"
                fill="currentColor"
                x={PlRXX}
                y={PlRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlRXX + ',' + PlRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ma-p-group-inner">
        <text
                id="Ma-planet-inner"
                className="Ma planet-ring__planet--inner"
                fill="currentColor"
                x={MaPlanetX}
                y={MaPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaPlanetX + ',' + MaPlanetY + ')'}
                >
                {MaSym}
        </text>
        <text
                id="Ma-sign-inner"
                className={MaSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={MaSignX}
                y={MaSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaSignX + ',' + MaSignY + ')'}
                >
                {MaSignSym}
        </text>
        <text
                id="Ma-degree-inner"
                className={MaRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={MaDegreeX}
                y={MaDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaDegreeX + ',' + MaDegreeY + ')'}
                >
                {MaDegree}{MaDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ma-minute-inner"
                className={MaRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={MaMinuteX}
                y={MaMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaMinuteX + ',' + MaMinuteY + ')'}
                >
                {MaMinute}
        </text>
                {MaRX === false ? null : <text
                id="Ma-rx-inner"
                className="Ma planet-ring__planet--inner rx"
                fill="currentColor"
                x={MaRXX}
                y={MaRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaRXX + ',' + MaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Sa-p-group-inner">
        <text
                id="Sa-planet-inner"
                className="Sa planet-ring__planet--inner"
                fill="currentColor"
                x={SaPlanetX}
                y={SaPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaPlanetX + ',' + SaPlanetY + ')'}
                >
                {SaSym}
        </text>
        <text
                id="Sa-sign-inner"
                className={SaSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={SaSignX}
                y={SaSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaSignX + ',' + SaSignY + ')'}
                >
                {SaSignSym}
        </text>
        <text
                id="Sa-degree-inner"
                className={SaRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={SaDegreeX}
                y={SaDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaDegreeX + ',' + SaDegreeY + ')'}
                >
                {SaDegree}{SaDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Sa-minute-inner"
                className={SaRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={SaMinuteX}
                y={SaMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaMinuteX + ',' + SaMinuteY + ')'}
                >
                {SaMinute}
        </text>
                {SaRX === false ? null : <text
                id="Sa-rx-inner"
                className="Sa planet-ring__planet--inner rx"
                fill="currentColor"
                x={SaRXX}
                y={SaRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaRXX + ',' + SaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>

        <g id="LoFo-p-group-inner">
        <text
                id="LoFo-planet-inner"
                className="LoFo planet-ring__planet--inner"
                fill="currentColor"
                x={LoFoPlanetX}
                y={LoFoPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoPlanetX + ',' + LoFoPlanetY + ')'}
                >
                {LoFoSym}
        </text>
        <text
                id="LoFo-sign-inner"
                className={LoFoSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={LoFoSignX}
                y={LoFoSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoSignX + ',' + LoFoSignY + ')'}
                >
                {LoFoSignSym}
        </text>
        <text
                id="LoFo-degree-inner"
                className="planet-ring__degree--inner"
                fill="currentColor"
                x={LoFoDegreeX}
                y={LoFoDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoDegreeX + ',' + LoFoDegreeY + ')'}
                >
                {LoFoDegree}{LoFoDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="LoFo-minute-inner"
                className="planet-ring__minute--inner"
                fill="currentColor"
                x={LoFoMinuteX}
                y={LoFoMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoMinuteX + ',' + LoFoMinuteY + ')'}
                >
                {LoFoMinute}
        </text>
        </g>

        <g id="Ne-p-group-inner">
        <text
                id="Ne-planet-inner"
                className="Ne planet-ring__planet--inner"
                fill="currentColor"
                x={NePlanetX}
                y={NePlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NePlanetX + ',' + NePlanetY + ')'}
                >
                {NeSym}
        </text>
        <text
                id="Ne-sign-inner"
                className={NeSign + " planet-ring__sign--inner"}
                fill="currentColor"
                x={NeSignX}
                y={NeSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeSignX + ',' + NeSignY + ')'}
                >
                {NeSignSym}
        </text>
        <text
                id="Ne-degree-inner"
                className={NeRX === true ? "planet-ring__degree--inner rx" : "planet-ring__degree--inner"}
                fill="currentColor"
                x={NeDegreeX}
                y={NeDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeDegreeX + ',' + NeDegreeY + ')'}
                >
                {NeDegree}{NeDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ne-minute-inner"
                className={NeRX === true ? "planet-ring__minute--inner rx" : "planet-ring__minute--inner"}
                fill="currentColor"
                x={NeMinuteX}
                y={NeMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeMinuteX + ',' + NeMinuteY + ')'}
                >
                {NeMinute}
        </text>
                {NeRX === false ? null : <text
                id="Ne-rx-inner"
                className="Ne planet-ring__planet--inner rx"
                fill="currentColor"
                x={NeRXX}
                y={NeRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeRXX + ',' + NeRXY + ')'}
                >
                {RXSym}
        </text>}

        </g>
        </g>

        <g className="planet-ring__content--outer">
        <g id="Mo-p-group-outer">
        <text
                id="Mo-planet-outer"
                className="Mo planet-ring__planet--outer"
                fill="currentColor"
                x={MoBPlanetX}
                y={MoBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoPlanetX==null ? '0' : MoPlanetX + ',' + MoPlanetY==null ? '0' : MoPlanetY + ')'}
                >
                {MoBSym}
        </text>
        <text
                id="Mo-sign-outer"
                className={MoBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={MoBSignX}
                y={MoBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoSignX==null ? '0' : MoSignX + ',' + MoSignY==null ? '0' : MoSignY + ')'}
                >
                {MoBSignSym}
        </text>
        <text
                id="Mo-degree-outer"
                className={"planet-ring__degree--outer"}
                fill="currentColor"
                x={MoBDegreeX}
                y={MoBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoDegreeX + ',' + MoDegreeY + ')'}
                >
                {MoBDegree}{MoBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Mo-minute-outer"
                className={"planet-ring__minute--outer"}
                fill="currentColor"
                x={MoBMinuteX}
                y={MoBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MoMinuteX + ',' + MoMinuteY + ')'}
                >
                {MoBMinute}
        </text>
        </g>
        <g id="Ve-p-group-outer">
        <text
                id="Ve-planet-outer"
                className="Ve planet-ring__planet--outer"
                fill="currentColor"
                x={VeBPlanetX}
                y={VeBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VePlanetX + ',' + VePlanetY + ')'}
                >
                {VeBSym}
        </text>
        <text
                id="Ve-sign-outer"
                className={VeBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={VeBSignX}
                y={VeBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeSignX + ',' + VeSignY + ')'}
                >
                {VeBSignSym}
        </text>
        <text
                id="Ve-degree-outer"
                className={VeBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={VeBDegreeX}
                y={VeBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeDegreeX + ',' + VeDegreeY + ')'}
                >
                {VeBDegree}{VeBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ve-minute-outer"
                className={VeBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={VeBMinuteX}
                y={VeBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeMinuteX + ',' + VeMinuteY + ')'}
                >
                {VeBMinute}
        </text>
                {VeBRX === false ? null: <text
                id="Ve-rx-outer"
                className="Ve planet-ring__planet--outer rx"
                fill="currentColor"
                x={VeBRXX}
                y={VeBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + VeRXX + ',' + VeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="ASC-p-group-outer">
        <text
                id="ASC-planet-outer"
                className="ASC planet-ring__planet--outer"
                fill="currentColor"
                x={ASCBPlanetX}
                y={ASCBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCPlanetX + ',' + ASCPlanetY + ')'}
                >
                {ASCBSym}
        </text>
        <text
                id="ASC-sign-outer"
                className={ASCBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={ASCBSignX}
                y={ASCBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCSignX + ',' + ASCSignY + ')'}
                >
                {ASCBSignSym}
        </text>
        <text
                id="ASC-degree-outer"
                className={"planet-ring__degree--outer"}
                fill="currentColor"
                x={ASCBDegreeX}
                y={ASCBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCDegreeX + ',' + ASCDegreeY + ')'}
                >
                {ASCBDegree}{ASCBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="ASC-minute-outer"
                className={"planet-ring__minute--outer"}
                fill="currentColor"
                x={ASCBMinuteX}
                y={ASCBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ASCMinuteX + ',' + ASCMinuteY + ')'}
                >
                {ASCBMinute}
        </text>
        </g>
        
        <g id="LoFo-p-group-outer">
        <text
                id="LoFo-planet-outer"
                className="LoFo planet-ring__planet--outer"
                fill="currentColor"
                x={LoFoBPlanetX}
                y={LoFoBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoPlanetX + ',' + LoFoPlanetY + ')'}
                >
                {LoFoBSym}
        </text>
        <text
                id="LoFo-sign-outer"
                className={LoFoBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={LoFoBSignX}
                y={LoFoBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoSignX + ',' + LoFoSignY + ')'}
                >
                {LoFoBSignSym}
        </text>
        <text
                id="LoFo-degree-outer"
                className={"planet-ring__degree--outer"}
                fill="currentColor"
                x={LoFoBDegreeX}
                y={LoFoBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoDegreeX + ',' + LoFoDegreeY + ')'}
                >
                {LoFoBDegree}{LoFoBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="LoFo-minute-outer"
                className={"planet-ring__minute--outer"}
                fill="currentColor"
                x={LoFoBMinuteX}
                y={LoFoBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + LoFoMinuteX + ',' + LoFoMinuteY + ')'}
                >
                {LoFoBMinute}
        </text>
        </g>

        <g id="Ra-p-group-outer">
        <text
                id="Ra-planet-outer"
                className="Ra planet-ring__planet--outer"
                fill="currentColor"
                x={RaBPlanetX}
                y={RaBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaPlanetX + ',' + RaPlanetY + ')'}
                >
                {RaBSym}
        </text>
        <text
                id="Ra-sign-outer"
                className={RaBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={RaBSignX}
                y={RaBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaSignX + ',' + RaSignY + ')'}
                >
                {RaBSignSym}
        </text>
        <text
                id="Ra-degree-outer"
                className={RaBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={RaBDegreeX}
                y={RaBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaDegreeX + ',' + RaDegreeY + ')'}
                >
                {RaBDegree}{RaBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ra-minute-outer"
                className={RaBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={RaBMinuteX}
                y={RaBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaMinuteX + ',' + RaMinuteY + ')'}
                >
                {RaBMinute}
        </text>
                {RaBRX === false ? null: <text
                id="Ra-rx-outer"
                className="Ra planet-ring__planet--outer rx"
                fill="currentColor"
                x={RaBRXX}
                y={RaBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + RaRXX + ',' + RaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Su-p-group-outer">
        <text
                id="Su-planet-outer"
                className="Su planet-ring__planet--outer"
                fill="currentColor"
                x={SuBPlanetX}
                y={SuBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuPlanetX + ',' + SuPlanetY + ')'}
                >
                {SuBSym}
        </text>
        <text
                id="Su-sign-outer"
                className={SuBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={SuBSignX}
                y={SuBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuSignX + ',' + SuSignY + ')'}
                >
                {SuBSignSym}
        </text>
        <text
                id="Su-degree-outer"
                className={"planet-ring__degree--outer"}
                fill="currentColor"
                x={SuBDegreeX}
                y={SuBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuDegreeX + ',' + SuDegreeY + ')'}
                >
                {SuBDegree}{SuBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Su-minute-outer"
                className={"planet-ring__minute--outer"}
                fill="currentColor"
                x={SuBMinuteX}
                y={SuBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SuMinuteX + ',' + SuMinuteY + ')'}
                >
                {SuBMinute}
        </text>
        </g>
        <g id="Ch-p-group-outer">
        <text
                id="Ch-planet-outer"
                className="Ch planet-ring__planet--outer"
                fill="currentColor"
                x={ChBPlanetX}
                y={ChBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChPlanetX + ',' + ChPlanetY + ')'}
                >
                {ChBSym}
        </text>
        <text
                id="Ch-sign-outer"
                className={ChBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={ChBSignX}
                y={ChBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChSignX + ',' + ChSignY + ')'}
                >
                {ChBSignSym}
        </text>
        <text
                id="Ch-degree-outer"
                className={ChBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={ChBDegreeX}
                y={ChBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChDegreeX + ',' + ChDegreeY + ')'}
                >
                {ChBDegree}{ChBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ch-minute-outer"
                className={ChBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={ChBMinuteX}
                y={ChBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChMinuteX + ',' + ChMinuteY + ')'}
                >
                {ChBMinute}
        </text>
                {ChBRX === false ? null : <text
                id="Ch-rx outer"
                className="Ch planet-ring__planet--outer rx"
                fill="currentColor"
                x={ChBRXX}
                y={ChBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ChRXX + ',' + ChRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Me-p-group-outer">
        <text
                id="Me-planet-outer"
                className="Me planet-ring__planet--outer"
                fill="currentColor"
                x={MeBPlanetX}
                y={MeBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MePlanetX + ',' + MePlanetY + ')'}
                >
                {MeBSym}
                
        </text>
        <text
                id="Me-sign-outer"
                className={MeBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={MeBSignX}
                y={MeBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeSignX + ',' + MeSignY + ')'}
                >
                {MeBSignSym}
        </text>
        <text
                id="Me-degree-outer"
                className={MeBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={MeBDegreeX}
                y={MeBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeDegreeX + ',' + MeDegreeY + ')'}
                >
                {MeBDegree}{MeBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Me-minute-outer"
                className={MeBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={MeBMinuteX}
                y={MeBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeMinuteX + ',' + MeMinuteY + ')'}
                >
                {MeBMinute}
        </text>
                {MeBRX === false ? null : <text
                id="Me-rx-outer"
                className="Me planet-ring__planet--outer rx"
                fill="currentColor"
                x={MeBRXX}
                y={MeBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MeRXX + ',' + MeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ju-p-group-outer">
        <text
                id="Ju-planet-outer"
                className="Ju planet-ring__planet--outer"
                fill="currentColor"
                x={JuBPlanetX}
                y={JuBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuPlanetX + ',' + JuPlanetY + ')'}
                >
                {JuBSym}
        </text>
        <text
                id="Ju-sign-outer"
                className={JuBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={JuBSignX}
                y={JuBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuSignX + ',' + JuSignY + ')'}
                >
                {JuBSignSym}
        </text>
        <text
                id="Ju-degree-outer"
                className={JuBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={JuBDegreeX}
                y={JuBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuDegreeX + ',' + JuDegreeY + ')'}
                >
                {JuBDegree}{JuBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ju-minute-outer"
                className={JuBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={JuBMinuteX}
                y={JuBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuMinuteX + ',' + JuMinuteY + ')'}
                >
                {JuBMinute}
        </text>
                {JuBRX === false ? null : <text
                id="Ju-rx-outer"
                className="Ju planet-ring__planet--outer rx"
                fill="currentColor"
                x={JuBRXX}
                y={JuBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + JuRXX + ',' + JuRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ur-p-group-outer">
        <text
                id="Ur-planet-outer"
                className="Ur planet-ring__planet--outer"
                fill="currentColor"
                x={UrBPlanetX}
                y={UrBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrPlanetX + ',' + UrPlanetY + ')'}
                >
                {UrBSym}
        </text>
        <text
                id="Ur-sign-outer"
                className={UrBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={UrBSignX}
                y={UrBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrSignX + ',' + UrSignY + ')'}
                >
                {UrBSignSym}
        </text>
        <text
                id="Ur-degree-outer"
                className={UrBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={UrBDegreeX}
                y={UrBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrDegreeX + ',' + UrDegreeY + ')'}
                >
                {UrBDegree}{UrBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ur-minute-outer"
                className={UrBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={UrBMinuteX}
                y={UrBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrMinuteX + ',' + UrMinuteY + ')'}
                >
                {UrBMinute}
        </text>
                {UrBRX === false ? null : <text
                id="Ur-rx-outer"
                className="Ur planet-ring__planet--outer rx"
                fill="currentColor"
                x={UrBRXX}
                y={UrBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + UrRXX + ',' + UrRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="IC-p-group-outer">
        <text
                id="IC-planet-outer"
                className="IC planet-ring__planet--outer"
                fill="currentColor"
                x={ICBPlanetX}
                y={ICBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICPlanetX + ',' + ICPlanetY + ')'}
                >
                {ICBSym}
        </text>
        <text
                id="IC-sign-outer"
                className={ICBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={ICBSignX}
                y={ICBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICSignX + ',' + ICSignY + ')'}
                >
                {ICBSignSym}
        </text>
        <text
                id="IC-degree-outer"
                className="IC planet-ring__degree--outer"
                fill="currentColor"
                x={ICBDegreeX}
                y={ICBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICDegreeX + ',' + ICDegreeY + ')'}
                >
                {ICBDegree}{ICBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="IC-minute-outer"
                className="IC planet-ring__minute--outer"
                fill="currentColor"
                x={ICBMinuteX}
                y={ICBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + ICMinuteX + ',' + ICMinuteY + ')'}
                >
                {ICBMinute}
        </text>
        </g>
        <g id="DSC-p-group-outer">
        <text
                id="DSC-planet-outer"
                className="DSC planet-ring__planet--outer"
                fill="currentColor"
                x={DSCBPlanetX}
                y={DSCBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCPlanetX + ',' + DSCPlanetY + ')'}
                >
                {DSCBSym}
        </text>
        <text
                id="DSC-sign-outer"
                className={DSCBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={DSCBSignX}
                y={DSCBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCSignX + ',' + DSCSignY + ')'}
                >
                {DSCBSignSym}
        </text>
        <text
                id="DSC-degree-outer"
                className="IC planet-ring__degree--outer"
                fill="currentColor"
                x={DSCBDegreeX}
                y={DSCBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCDegreeX + ',' + DSCDegreeY + ')'}
                >
                {DSCBDegree}{DSCBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="DSC-minute-outer"
                className="IC planet-ring__minute--outer"
                fill="currentColor"
                x={DSCBMinuteX}
                y={DSCBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + DSCMinuteX + ',' + DSCMinuteY + ')'}
                >
                {DSCBMinute}
        </text>
        </g>
        <g id="Ke-p-group-outer">
        <text
                id="Ke-planet-outer"
                className="Ke planet-ring__planet--outer"
                fill="currentColor"
                x={KeBPlanetX}
                y={KeBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KePlanetX + ',' + KePlanetY + ')'}
                >
                {KeBSym}
        </text>
        <text
                id="Ke-sign-outer"
                className={KeSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={KeBSignX}
                y={KeBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeSignX + ',' + KeSignY + ')'}
                >
                {KeBSignSym}
        </text>
        <text
                id="Ke-degree-outer"
                className={KeBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={KeBDegreeX}
                y={KeBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeDegreeX + ',' + KeDegreeY + ')'}
                >
                {KeBDegree}{KeBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ke-minute-outer"
                className={KeBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"} 
                fill="currentColor"
                x={KeBMinuteX}
                y={KeBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeMinuteX + ',' + KeMinuteY + ')'}
                >
                {KeBMinute}
        </text>
                {KeBRX === false ? null : <text
                id="Ke-rx-outer"
                className="Ke planet-ring__planet--outer rx"
                fill="currentColor"
                x={KeBRXX}
                y={KeBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + KeRXX + ',' + KeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="MC-p-group-outer">
        <text
                id="MC-planet-outer"
                className="MC planet-ring__planet--outer"
                fill="currentColor"
                x={MCBPlanetX}
                y={MCBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCPlanetX + ',' + MCPlanetY + ')'}
                >
                {MCBSym}
        </text>
        <text
                id="MC-sign-outer"
                className={MCBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={MCBSignX}
                y={MCBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCSignX + ',' + MCSignY + ')'}
                >
                {MCBSignSym}
        </text>
        <text
                id="MC-degree-outer"
                className={"planet-ring__degree--outer"}
                fill="currentColor"
                x={MCBDegreeX}
                y={MCBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCDegreeX + ',' + MCDegreeY + ')'}
                >
                {MCBDegree}{MCBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="MC-minute-outer"
                className={"planet-ring__minute--outer"}
                fill="currentColor"
                x={MCBMinuteX}
                y={MCBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MCMinuteX + ',' + MCMinuteY + ')'}
                >
                {MCBMinute}
        </text>
        </g>
        <g id="Pl-p-group-outer">
        <text
                id="Pl-planet-outer"
                className="Pl planet-ring__planet--outer"
                fill="currentColor"
                x={PlBPlanetX}
                y={PlBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlPlanetX + ',' + PlPlanetY + ')'}
                >
                {PlBSym}
        </text>
        <text
                id="Pl-sign-outer"
                className={PlBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={PlBSignX}
                y={PlBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlSignX + ',' + PlSignY + ')'}
                >
                {PlBSignSym}
        </text>
        <text
                id="Pl-degree-outer"
                className={PlBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={PlBDegreeX}
                y={PlBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlDegreeX + ',' + PlDegreeY + ')'}
                >
                {PlBDegree}{PlBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Pl-minute-outer"
                className={PlBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={PlBMinuteX}
                y={PlBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlMinuteX + ',' + PlMinuteY + ')'}
                >
                {PlBMinute}
        </text>
                {PlBRX === false ? null : <text
                id="Pl-rx-outer"
                className="Pl planet-ring__planet--outer rx"
                fill="currentColor"
                x={PlBRXX}
                y={PlBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + PlRXX + ',' + PlRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ma-p-group-outer">
        <text
                id="Ma-planet-outer"
                className="Ma planet-ring__planet--outer"
                fill="currentColor"
                x={MaBPlanetX}
                y={MaBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaPlanetX + ',' + MaPlanetY + ')'}
                >
                {MaBSym}
        </text>
        <text
                id="Ma-sign-outer"
                className={MaBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={MaBSignX}
                y={MaBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaSignX + ',' + MaSignY + ')'}
                >
                {MaBSignSym}
        </text>
        <text
                id="Ma-degree-outer"
                className={MaBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={MaBDegreeX}
                y={MaBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaDegreeX + ',' + MaDegreeY + ')'}
                >
                {MaBDegree}{MaBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ma-minute-outer"
                className={MaBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={MaBMinuteX}
                y={MaBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaMinuteX + ',' + MaMinuteY + ')'}
                >
                {MaBMinute}
        </text>
                {MaBRX === false ? null : <text
                id="Ma-rx-outer"
                className="Ma planet-ring__planet--outer rx"
                fill="currentColor"
                x={MaBRXX}
                y={MaBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + MaRXX + ',' + MaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Sa-p-group-outer">
        <text
                id="Sa-planet-outer"
                className="Sa planet-ring__planet--outer"
                fill="currentColor"
                x={SaBPlanetX}
                y={SaBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaPlanetX + ',' + SaPlanetY + ')'}
                >
                {SaBSym}
        </text>
        <text
                id="Sa-sign-outer"
                className={SaBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={SaBSignX}
                y={SaBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaSignX + ',' + SaSignY + ')'}
                >
                {SaBSignSym}
        </text>
        <text
                id="Sa-degree-outer"
                className={SaBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={SaBDegreeX}
                y={SaBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaDegreeX + ',' + SaDegreeY + ')'}
                >
                {SaBDegree}{SaBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Sa-minute-outer"
                className={SaBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={SaBMinuteX}
                y={SaBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaMinuteX + ',' + SaMinuteY + ')'}
                >
                {SaBMinute}
        </text>
                {SaBRX === false ? null : <text
                id="Sa-rx-outer"
                className="Sa planet-ring__planet--outer rx"
                fill="currentColor"
                x={SaBRXX}
                y={SaBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + SaRXX + ',' + SaRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        <g id="Ne-p-group-outer">
        <text
                id="Ne-planet-outer"
                className="Ne planet-ring__planet--outer"
                fill="currentColor"
                x={NeBPlanetX}
                y={NeBPlanetY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NePlanetX + ',' + NePlanetY + ')'}
                >
                {NeBSym}
        </text>
        <text
                id="Ne-sign-outer"
                className={NeBSign + " planet-ring__sign--outer"}
                fill="currentColor"
                x={NeBSignX}
                y={NeBSignY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeSignX + ',' + NeSignY + ')'}
                >
                {NeBSignSym}
        </text>
        <text
                id="Ne-degree-outer"
                className={NeBRX === true ? "planet-ring__degree--outer rx" : "planet-ring__degree--outer"}
                fill="currentColor"
                x={NeBDegreeX}
                y={NeBDegreeY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeDegreeX + ',' + NeDegreeY + ')'}
                >
                {NeBDegree}{NeBDegree == '' ? null : DegreeSym}
        </text>
        <text
                id="Ne-minute-outer"
                className={NeBRX === true ? "planet-ring__minute--outer rx" : "planet-ring__minute--outer"}
                fill="currentColor"
                x={NeBMinuteX}
                y={NeBMinuteY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeMinuteX + ',' + NeMinuteY + ')'}
                >
                {NeBMinute}
        </text>
                {NeBRX === false ? null : <text
                id="Ne-rx-outer"
                className="Ne planet-ring__planet--outer rx"
                fill="currentColor"
                x={NeBRXX}
                y={NeBRXY}
                textAnchor="middle"
                dominantBaseline="central"
                // transform={'rotate(0,' + NeRXX + ',' + NeRXY + ')'}
                >
                {RXSym}
        </text>}
        </g>
        </g>


        
        </svg>
)
export { BiChartSvg as ReactComponent }

{/* <BiChartBSvg
           
                MoBSym={props.moBVals.MoBSym}
                MoBPlanetX={props.moBVals.MoBPlanetX}
                MoBPlanetY={props.moBVals.MoBPlanetY}
                MoBSign={props.moBVals.MoBSign}
                MoBSignSym={props.moBVals.MoBSignSym}
                MoBSignX={props.moBVals.MoBSignX}
                MoBSignY={props.moBVals.MoBSignY}
                MoBDegree={props.moBVals.MoBDegree}
                MoBDegreeX={props.moBVals.MoBDegreeX}
                MoBDegreeY={props.moBVals.MoBDegreeY}
                MoBMinute={props.moBVals.MoBMinute}
                MoBMinuteX={props.moBVals.MoBMinuteX}
                MoBMinuteY={props.moBVals.MoBMinuteY}
                VeBSym={props.veBVals.VeBSym}
                VeBSign={props.veBVals.VeBSign}
                VeBPlanetX={props.veBVals.VeBPlanetX}
                VeBPlanetY={props.veBVals.VeBPlanetY}
                VeBSignSym={props.veBVals.VeBSignSym}
                VeBSignX={props.veBVals.VeBSignX}
                VeBSignY={props.veBVals.VeBSignY}
                VeBDegree={props.veBVals.VeBDegree}
                VeBDegreeX={props.veBVals.VeBDegreeX}
                VeBDegreeY={props.veBVals.VeBDegreeY}
                VeBMinute={props.veBVals.VeBMinute}
                VeBMinuteX={props.veBVals.VeBMinuteX}
                VeBMinuteY={props.veBVals.VeBMinuteY}
                VeBRX={props.veBVals.VeBRX}
                VeBRXX={props.veBVals.VeBRXX}
                VeBRXY={props.veBVals.VeBRXY}
                ASCBSym={props.ascBVals.ASCBSym}
                ASCBPlanetX={props.ascBVals.ASCBPlanetX}
                ASCBPlanetY={props.ascBVals.ASCBPlanetY}
                ASCBSign={props.ascBVals.ASCBSign}
                ASCBSignSym={props.ascBVals.ASCBSignSym}
                ASCBSignX={props.ascBVals.ASCBSignX}
                ASCBSignY={props.ascBVals.ASCBSignY}
                ASCBDegree={props.ascBVals.ASCBDegree}
                ASCBDegreeX={props.ascBVals.ASCBDegreeX}
                ASCBDegreeY={props.ascBVals.ASCBDegreeY}
                ASCBMinute={props.ascBVals.ASCBMinute}
                ASCBMinuteX={props.ascBVals.ASCBMinuteX}
                ASCBMinuteY={props.ascBVals.ASCBMinuteY}
                RaBSym={props.raBVals.RaBSym}
                RaBPlanetX={props.raBVals.RaBPlanetX}
                RaBPlanetY={props.raBVals.RaBPlanetY}
                RaBSign={props.raBVals.RaBSign}
                RaBSignSym={props.raBVals.RaBSignSym}
                RaBSignX={props.raBVals.RaBSignX}
                RaBSignY={props.raBVals.RaBSignY}
                RaBDegree={props.raBVals.RaBDegree}
                RaBDegreeX={props.raBVals.RaBDegreeX}
                RaBDegreeY={props.raBVals.RaBDegreeY}
                RaBMinute={props.raBVals.RaBMinute}
                RaBMinuteX={props.raBVals.RaBMinuteX}
                RaBMinuteY={props.raBVals.RaBMinuteY}
                RaBRX={props.raBVals.RaBRX}
                RaBRXX={props.raBVals.RaBRXX}
                RaBRXY={props.raBVals.RaBRXY}
                SuBSym={props.suBVals.SuBSym}
                SuBPlanetX={props.suBVals.SuBPlanetX}
                SuBPlanetY={props.suBVals.SuBPlanetY}
                SuBSign={props.suBVals.SuBSign}
                SuBSignSym={props.suBVals.SuBSignSym}
                SuBSignX={props.suBVals.SuBSignX}
                SuBSignY={props.suBVals.SuBSignY}
                SuBDegree={props.suBVals.SuBDegree}
                SuBDegreeX={props.suBVals.SuBDegreeX}
                SuBDegreeY={props.suBVals.SuBDegreeY}
                SuBMinute={props.suBVals.SuBMinute}
                SuBMinuteX={props.suBVals.SuBMinuteX}
                SuBMinuteY={props.suBVals.SuBMinuteY}
                ChBPlanetX={props.chBVals.ChBPlanetX}
                ChBPlanetY={props.chBVals.ChBPlanetY}
                ChBSym={props.chBVals.ChBSym}
                ChBSign={props.chBVals.ChBSign}
                ChBSignSym={props.chBVals.ChBSignSym}
                ChBSignX={props.chBVals.ChBSignX}
                ChBSignY={props.chBVals.ChBSignY}
                ChBDegree={props.chBVals.ChBDegree}
                ChBDegreeX={props.chBVals.ChBDegreeX}
                ChBDegreeY={props.chBVals.ChBDegreeY}
                ChBMinute={props.chBVals.ChBMinute}
                ChBMinuteX={props.chBVals.ChBMinuteX}
                ChBMinuteY={props.chBVals.ChBMinuteY}
                ChBRX={props.chBVals.ChBRX}
                ChBRXX={props.chBVals.ChBRXX}
                ChBRXY={props.chBVals.ChBRXY}
                MeBSym={props.meBVals.MeBSym}
                MeBPlanetX={props.meBVals.MeBPlanetX}
                MeBPlanetY={props.meBVals.MeBPlanetY}
                MeBSign={props.meBVals.MeBSign}
                MeBSignSym={props.meBVals.MeBSignSym}
                MeBSignX={props.meBVals.MeBSignX}
                MeBSignY={props.meBVals.MeBSignY}
                MeBDegree={props.meBVals.MeBDegree}
                MeBDegreeX={props.meBVals.MeBDegreeX}
                MeBDegreeY={props.meBVals.MeBDegreeY}
                MeBMinute={props.meBVals.MeBMinute}
                MeBMinuteX={props.meBVals.MeBMinuteX}
                MeBMinuteY={props.meBVals.MeBMinuteY}
                MeBRX={props.meBVals.MeBRX}
                MeBRXX={props.meBVals.MeBRXX}
                MeBRXY={props.meBVals.MeBRXY}
                JuBSym={props.juBVals.JuBSym}
                JuBPlanetX={props.juBVals.JuBPlanetX}
                JuBPlanetY={props.juBVals.JuBPlanetY}
                JuBSign={props.juBVals.JuBSign}
                JuBSignSym={props.juBVals.JuBSignSym}
                JuBSignX={props.juBVals.JuBSignX}
                JuBSignY={props.juBVals.JuBSignY}
                JuBDegree={props.juBVals.JuBDegree}
                JuBDegreeX={props.juBVals.JuBDegreeX}
                JuBDegreeY={props.juBVals.JuBDegreeY}
                JuBMinute={props.juBVals.JuBMinute}
                JuBMinuteX={props.juBVals.JuBMinuteX}
                JuBMinuteY={props.juBVals.JuBMinuteY}
                JuBRX={props.juBVals.JuBRX}
                JuBRXX={props.juBVals.JuBRXX}
                JuBRXY={props.juBVals.JuBRXY}
                UrBSym={props.urBVals.UrBSym}
                UrBPlanetX={props.urBVals.UrBPlanetX}
                UrBPlanetY={props.urBVals.UrBPlanetY}
                UrBSign={props.urBVals.UrBSign}
                UrBSignSym={props.urBVals.UrBSignSym}
                UrBSignX={props.urBVals.UrBSignX}
                UrBSignY={props.urBVals.UrBSignY}
                UrBDegree={props.urBVals.UrBDegree}
                UrBDegreeX={props.urBVals.UrBDegreeX}
                UrBDegreeY={props.urBVals.UrBDegreeY}
                UrBMinute={props.urBVals.UrBMinute}
                UrBMinuteX={props.urBVals.UrBMinuteX}
                UrBMinuteY={props.urBVals.UrBMinuteY}
                UrBRX={props.urBVals.UrBRX}
                UrBRXX={props.urBVals.UrBRXX}
                UrBRXY={props.urBVals.UrBRXY}
                ICBSym={props.icBVals.ICBSym}
                ICBPlanetX={props.icBVals.ICBPlanetX}
                ICBPlanetY={props.icBVals.ICBPlanetY}
                ICBSign={props.icBVals.ICBSign}
                ICBSignSym={props.icBVals.ICBSignSym}
                ICBSignX={props.icBVals.ICBSignX}
                ICBSignY={props.icBVals.ICBSignY}
                ICBDegree={props.icBVals.ICBDegree}
                ICBDegreeX={props.icBVals.ICBDegreeX}
                ICBDegreeY={props.icBVals.ICBDegreeY}
                ICBMinute={props.icBVals.ICBMinute}
                ICBMinuteX={props.icBVals.ICBMinuteX}
                ICBMinuteY={props.icBVals.ICBMinuteY}
                MCBSym={props.mcBVals.MCBSym}
                MCBPlanetX={props.mcBVals.MCBPlanetX}
                MCBPlanetY={props.mcBVals.MCBPlanetY}
                MCBSign={props.mcBVals.MCBSign}
                MCBSignSym={props.mcBVals.MCBSignSym}
                MCBSignX={props.mcBVals.MCBSignX}
                MCBSignY={props.mcBVals.MCBSignY}
                MCBDegree={props.mcBVals.MCBDegree}
                MCBDegreeX={props.mcBVals.MCBDegreeX}
                MCBDegreeY={props.mcBVals.MCBDegreeY}
                MCBMinute={props.mcBVals.MCBMinute}
                MCBMinuteX={props.mcBVals.MCBMinuteX}
                MCBMinuteY={props.mcBVals.MCBMinuteY}
                DSCBSym={props.dscBVals.DSCBSym}
                DSCBPlanetX={props.dscBVals.DSCBPlanetX}
                DSCBPlanetY={props.dscBVals.DSCBPlanetY}
                DSCBSign={props.dscBVals.DSCBSign}
                DSCBSignSym={props.dscBVals.DSCBSignSym}
                DSCBSignX={props.dscBVals.DSCBSignX}
                DSCBSignY={props.dscBVals.DSCBSignY}
                DSCBDegree={props.dscBVals.DSCBDegree}
                DSCBDegreeX={props.dscBVals.DSCBDegreeX}
                DSCBDegreeY={props.dscBVals.DSCBDegreeY}
                DSCBMinute={props.dscBVals.DSCBMinute}
                DSCBMinuteX={props.dscBVals.DSCBMinuteX}
                DSCBMinuteY={props.dscBVals.DSCBMinuteY}
                KeBSym={props.keBVals.KeBSym}
                KeBPlanetX={props.keBVals.KeBPlanetX}
                KeBPlanetY={props.keBVals.KeBPlanetY}
                KeBSign={props.keBVals.KeBSign}
                KeBSignSym={props.keBVals.KeBSignSym}
                KeBSignX={props.keBVals.KeBSignX}
                KeBSignY={props.keBVals.KeBSignY}
                KeBDegree={props.keBVals.KeBDegree}
                KeBDegreeX={props.keBVals.KeBDegreeX}
                KeBDegreeY={props.keBVals.KeBDegreeY}
                KeBMinute={props.keBVals.KeBMinute}
                KeBMinuteX={props.keBVals.KeBMinuteX}
                KeBMinuteY={props.keBVals.KeBMinuteY}
                KeBRX={props.keBVals.KeBRX}
                KeBRXX={props.keBVals.KeBRXX}
                KeBRXY={props.keBVals.KeBRXY}
                PlBSym={props.plBVals.PlBSym}
                PlBPlanetX={props.plBVals.PlBPlanetX}
                PlBPlanetY={props.plBVals.PlBPlanetY}
                PlBSign={props.plBVals.PlBSign}
                PlBSignSym={props.plBVals.PlBSignSym}
                PlBSignX={props.plBVals.PlBSignX}
                PlBSignY={props.plBVals.PlBSignY}
                PlBDegree={props.plBVals.PlBDegree}
                PlBDegreeX={props.plBVals.PlBDegreeX}
                PlBDegreeY={props.plBVals.PlBDegreeY}
                PlBMinute={props.plBVals.PlBMinute}
                PlBMinuteX={props.plBVals.PlBMinuteX}
                PlBMinuteY={props.plBVals.PlBMinuteY}
                PlBRX={props.plBVals.PlBRX}
                PlBRXX={props.plBVals.PlBRXX}
                PlBRXY={props.plBVals.PlBRXY}
                MaBSym={props.maBVals.MaBSym}
                MaBPlanetX={props.maBVals.MaBPlanetX}
                MaBPlanetY={props.maBVals.MaBPlanetY}
                MaBSign={props.maBVals.MaBSign}
                MaBSignSym={props.maBVals.MaBSignSym}
                MaBSignX={props.maBVals.MaBSignX}
                MaBSignY={props.maBVals.MaBSignY}
                MaBDegree={props.maBVals.MaBDegree}
                MaBDegreeX={props.maBVals.MaBDegreeX}
                MaBDegreeY={props.maBVals.MaBDegreeY}
                MaBMinute={props.maBVals.MaBMinute}
                MaBMinuteX={props.maBVals.MaBMinuteX}
                MaBMinuteY={props.maBVals.MaBMinuteY}
                MaBRX={props.maBVals.MaBRX}
                MaBRXX={props.maBVals.MaBRXX}
                MaBRXY={props.maBVals.MaBRXY}
                SaBSym={props.saBVals.SaBSym}
                SaBPlanetX={props.saBVals.SaBPlanetX}
                SaBPlanetY={props.saBVals.SaBPlanetY}
                SaBSign={props.saBVals.SaBSign}
                SaBSignSym={props.saBVals.SaBSignSym}
                SaBSignX={props.saBVals.SaBSignX}
                SaBSignY={props.saBVals.SaBSignY}
                SaBDegree={props.saBVals.SaBDegree}
                SaBDegreeX={props.saBVals.SaBDegreeX}
                SaBDegreeY={props.saBVals.SaBDegreeY}
                SaBMinute={props.saBVals.SaBMinute}
                SaBMinuteX={props.saBVals.SaBMinuteX}
                SaBMinuteY={props.saBVals.SaBMinuteY}
                SaBRX={props.saBVals.SaBRX}
                SaBRXX={props.saBVals.SaBRXX}
                SaBRXY={props.saBVals.SaBRXY}
                NeBSym={props.neBVals.NeBSym}
                NeBPlanetX={props.neBVals.NeBPlanetX}
                NeBPlanetY={props.neBVals.NeBPlanetY}
                NeBSign={props.neBVals.NeBSign}
                NeBSignSym={props.neBVals.NeBSignSym}
                NeBSignX={props.neBVals.NeBSignX}
                NeBSignY={props.neBVals.NeBSignY}
                NeBDegree={props.neBVals.NeBDegree}
                NeBDegreeX={props.neBVals.NeBDegreeX}
                NeBDegreeY={props.neBVals.NeBDegreeY}
                NeBMinute={props.neBVals.NeBMinute}
                NeBMinuteX={props.neBVals.NeBMinuteX}
                NeBMinuteY={props.neBVals.NeBMinuteY}
                NeBRX={props.neBVals.NeBRX}
                NeBRXX={props.neBVals.NeBRXX}
                NeBRXY={props.neBVals.NeBRXY} 
                RXBSym={props.RXBSym} 
                DegreeBSym = {props.DegreeBSym} /> */}

        {/* <g>
    <path
      transform="translate(-22,-22) scale(1.02 1.02)"
      d="M432.83,393.14c-16.51,9.68-30.26,23.54-39.82,40.13L0,205.74C49.75,120.84,120.67,49.85,205.5,0l227.33,393.14h0Z"
      className="hover-house" id="house-11" 
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M862.75,77.54l-232.73,403.23c-16.03-9.16-34.59-14.39-54.37-14.41l.83-465h.07c104.2,0,201.92,27.72,286.2,76.18Z"
    className="hover-house" id="house-9"
      />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M575.05.86v465.16c-1.01-.04-2.03-.05-3.04-.05-19.37,0-37.57,5.03-53.45,13.89L288.05,76.86C372.78,28.48,470.71.86,575.05.86Z"
    className="hover-house" id="house-10"
      />
  </g>
  <g>
  <path 
    transform="translate(-102,-100)"
    d="M684.61,574.09c.04-1.04.05-2.07.05-3.11,0-17.84-4.19-34.69-11.66-49.6l400.45-230.87c48.06,83.81,75.83,180.87,76.55,284.39l-465.39-.8Z"
    className="hover-house" id="house-7"
    /> 
  </g>
  <g>
  <path
    transform="translate(-100,-100)" 
    d="M1072.7,287.29l-402.31,233.32s-.02-.03-.03-.05c-9.73-16.52-23.66-30.26-40.32-39.78l232.68-402.68c86.91,50.2,159.47,122.48,209.98,209.19Z"
    className="hover-house" id="house-8"
    />
  </g>

  <g>
  <path 
    transform="translate(-100,-100)"
    d="M1151.55,576.36c0,104.83-28.05,203.1-77.07,287.73l-403.58-232.84c9.32-16.16,14.65-34.9,14.65-54.89h466Z"
    className="hover-house" id="house-6"
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M630.75,671.17c16.9-9.92,30.97-24.12,40.76-41.12l402.24,233.16c-50.92,87-123.51,159.75-210.33,210.84l-232.67-402.88h0Z"
    className="hover-house" id="house-5"
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M575.32,1149.8v-465.16c1.01.04,2.03.05,3.04.05,19.37,0,37.57-5.03,53.45-13.89l230.51,403c-84.73,48.38-182.66,76-287,76Z"
    className="hover-house" id="house-4"
    />
    </g>
    <g>
  <path 
    transform="translate(-100,-100)"
    d="M288.22,1073.37l232.73-403.23c16.03,9.16,34.59,14.39,54.37,14.41l-.83,465h-.07c-104.2,0-201.92-27.72-286.2-76.18h0Z"
    className="hover-house" id="house-3"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M77.76,863.89l402.31-233.32s.02.03.03.05c9.73,16.52,23.66,30.26,40.32,39.78l-232.68,402.68c-86.91-50.2-159.47-122.48-209.98-209.19Z"
    className="hover-house" id="house-2"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M466.87,576.09c-.04,1.05-.04,2.1-.04,3.15.06,18.07,4.32,35.12,11.85,50.19l-400.5,235.14C29.74,779.86,1.58,681.67.51,576.84l466.36-.76h0Z"
    className="hover-house" id="house-1"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M.5,574.55c0-104.83,28.05-203.1,77.07-287.73l403.58,232.84c-9.32,16.16-14.65,34.9-14.65,54.89H.5s0,0,0,0Z"
    className="hover-house" id="house-12"
    />
    </g> */}
    {/* <circle 
      className="hover-chart-border"
      cx={centerX}
      cy={centerY}
      r={signBorderRadius}
      fill="currentColor"
      /> */}
